module.exports = __webpack_public_path__ + "static/media/saved_fishing_marker.977d6741.svg";